import { defaultWrittenAbilityData } from '../../../../backend/config/classifiers/defaults/DefaultWrittenAbilityData';
import { writtenAbilitySchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers, allowManageSkillsAndTrainingsClassifiers } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const writtenAbilityEntityName = 'writtenAbility';
const writtenAbilityColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { displayOrder: {
        type: 'number',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineWrittenAbilityClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: writtenAbilityColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { displayOrder: params.data.displayOrder, search: [params.data.name, params.data.status, params.data.displayOrder].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState) && !allowManageSkillsAndTrainingsClassifiers(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultWrittenAbilityData,
        publicData: [
            {
                displayOrder: true,
            },
        ],
    }, writtenAbilitySchema);
}
